


















import Vue from 'vue';
import Component from 'vue-class-component';
import { State, Mutation, Action } from 'vuex-class';
import { Post } from '@/modules/blog/types'


/**
 * Dialogo de confirmación para elminar una publicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class PostDeletionConfirm extends Vue {
    @State(state => state.blog.showPostDeletionConfirm)
    public visible: boolean

    public deleting = false

    /**
     * Mutación para mostrar u ocultar el dialogo para confirmar el borrado
     * de una publicación
     */
    @Mutation('blog/showPostDeletionConfirm')
    public showConfirm: (show: boolean) => void

    /**
     * Mutación que define la publicación que se va a eliminar
     */
    @Mutation('blog/setPostToDelete')
    public setPostToDelete: (post: Post) => void

    @Action('blog/deletePost')
    public deletePost: (payload?: {updatePagination: boolean}) => void

    /**
     * Muestra u oculta el modal
     */
    public showDialog (visible: boolean) {
        if (!visible) {
            this.setPostToDelete(new Post())
            this.showConfirm(visible)
            return
        }

        this.showConfirm(visible)
    }

    public async confirm () {
        this.deleting = true
        await this.deletePost({updatePagination: true})

        this.deleting = false
        this.showConfirm(false)
    }

    /**
     * Captura cualquier producido al intentar eliminar la publicación
     *
     * @param error
     */
    public errorCaptured (error: Error) {
       this.deleting = false
       this.showConfirm(false)
    }
}

